// Purpose: Composes the small set of intentional BayHive component exceptions.
// Each sibling owns one cohesive component family; Lara remains the default for
// everything not explicitly included here.
import buttonComponents from './button.js';
import dataComponents from './data.js';
import dialogComponents from './dialog.js';
import feedbackComponents from './feedback.js';
import navigationComponents from './navigation.js';
import selectionComponents from './selection.js';

export const componentExceptions = {
  ...buttonComponents,
  ...selectionComponents,
  ...dataComponents,
  ...dialogComponents,
  ...feedbackComponents,
  ...navigationComponents,
};

export default componentExceptions;
